export const benefits = [
  {
    id: '1',
    iconName: 'graphDown',
    title: 'Prazos mais longos',
    description: 'Carência de 3 meses para pagar a primeira parcela e até 240 meses para pagar o crédito.'
  },
  {
    id: '2',
    iconName: 'person',
    title: 'Crédito para PF e PJ',
    description: 'Condições de financiamento disponíveis para pessoa física e pessoa jurídica.'
  },
  {
    id: '3',
    iconName: 'file',
    title: 'Acompanhamento da obra',
    description: 'Tenha crédito liberado de acordo com a evolução da sua obra.'
  },
  {
    id: '4',
    iconName: 'sell',
    title: 'Terreno com saldo devedor',
    description: `Utilize um terreno não quitado como garantia, unificando o saldo devedor do terreno ao 
    crédito tomado para construção. (Sujeito à análise).`
  }
]
